module.exports = __webpack_public_path__ + "/images/cover-landing-wishlist-desk.0fd606d.jpg";